/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, ReactElement, useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NumericInput } from '../../components/DesignSystem';
import { CreditsProjectMensualitesRules, CreditsProjectRestantRules } from '../../components/DesignSystem/InputRules';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import S from './styles';

const Credits: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { loans },
    geoLoc,
    dispatch,
  } = useContext(store);
  const [immoblierTotal1, setImmoblierTotal1] = useState(0);
  const [immoblierTotal2, setImmoblierTotal2] = useState(0);

  const [consumerTotal1, setConsumerTotal1] = useState(0);
  const [consumerTotal2, setConsumerTotal2] = useState(0);
  const [initialState1, setInitialState1] = useState<any>([]);
  const [initialState2, setInitialState2] = useState<any>([]);
  function localeString(x: string | number, sep: string, grp: number) {
    let sx = ('' + x).split('.'),
      s = '',
      i,
      j;
    sep || (sep = ' '); // default seperator
    grp || grp === 0 || (grp = 3); // default grouping
    i = sx[0].length;
    while (i > grp) {
      j = i - grp;
      s = sep + sx[0].slice(j, i) + s;
      i = j;
    }
    s = sx[0].slice(0, i) + s;
    sx[0] = s;
    return sx.join('.');
  }

  const realEstateLoans: any = initialState1;
  const consumerLoans: any = initialState2;
  useEffect(() => {
    if (loans?.realEstateLoans !== undefined) setInitialState1(loans?.realEstateLoans);
    if (loans?.consumerLoans !== undefined) setInitialState2(loans?.consumerLoans);
  }, [loans?.realEstateLoans, loans?.consumerLoans]);

  useEffect(() => {
    if (loans?.realEstateLoans !== undefined) {
      setImmoblierTotal1(Number(loans?.realEstateLoans?.reduce((s, i) => (s += i.emi), 0)));
      setImmoblierTotal2(Number(loans?.realEstateLoans?.reduce((s, i) => (s += i.amount), 0)));
    }
    if (loans?.consumerLoans !== undefined) {
      setConsumerTotal1(Number(loans?.consumerLoans?.reduce((s, i) => (s += i.emi), 0)));
      setConsumerTotal2(Number(loans?.consumerLoans?.reduce((s, i) => (s += i.amount), 0)));
    }
  }, [loans?.consumerLoans, loans?.realEstateLoans]);

  // Immobilier functions
  const handleImmoblierRemoveListItem = () => {
    const values = [...realEstateLoans];
    dispatch(updateStore({ loans: { realEstateLoans: values.slice(0, -1) } }));
  };

  const handleImmoblierAddFields = () => {
    dispatch(
      updateStore({
        loans: {
          realEstateLoans: [...realEstateLoans, { id: uuidv4(), emi: '', amount: '' }],
        },
      }),
    );
  };
  const ImmobilierEmiChange = (
    id: string,
    e: Event & { currentTarget?: { value?: unknown; id?: string; name?: string } | null },
  ) => {
    const index = realEstateLoans.findIndex((i: any) => i.id === id);
    const _list = [...realEstateLoans] as any;
    _list[index].emi = Number(String(e.currentTarget?.value).replace(/\s/g, ''));

    dispatch(updateStore({ loans: { realEstateLoans: _list } }));
  };
  const ImmobilierAmountChange = (
    id: string,
    e: Event & { currentTarget?: { value?: unknown; id?: string; name?: string } | null },
  ) => {
    const index = realEstateLoans.findIndex((i: any) => i.id === id);
    const _list = [...realEstateLoans] as any;
    _list[index].amount = Number(String(e.currentTarget?.value).replace(/\s/g, ''));

    dispatch(updateStore({ loans: { realEstateLoans: _list } }));
  };
  // Consumer functions
  const handleConsumerRemoveListItem = () => {
    const values = [...consumerLoans];
    dispatch(updateStore({ loans: { consumerLoans: values.slice(0, -1) } }));
  };
  const handleConsumerAddFields = () => {
    dispatch(
      updateStore({
        loans: {
          consumerLoans: [...consumerLoans, { id: uuidv4(), emi: '', amount: '' }],
        },
      }),
    );
  };
  const ConsumerEmiChange = (
    id: string,
    e: Event & { currentTarget?: { value?: unknown; id?: string; name?: string } | null },
  ) => {
    const index = consumerLoans.findIndex((i: any) => i.id === id);
    const _list = [...consumerLoans] as any;
    _list[index].emi = Number(String(e.currentTarget?.value).replace(/\s/g, ''));

    dispatch(updateStore({ loans: { consumerLoans: _list } }));
  };
  const ConsumerAmountChange = (
    id: string,
    e: Event & { currentTarget?: { value?: unknown; id?: string; name?: string } | null },
  ) => {
    const index = consumerLoans.findIndex((i: any) => i.id === id);
    const _list = [...consumerLoans] as any;
    _list[index].amount = Number(String(e.currentTarget?.value).replace(/\s/g, ''));

    dispatch(updateStore({ loans: { consumerLoans: _list } }));
  };

  return (
    <>
      <S.CreditsContainer>
        {/* immobilier credits */}
        {geoLoc === 'CTLM' && (
          <>
            <S.CreditsFlex>
              <S.Text>Combien de crédit(s) immoblier(s) souhaitez-vous regrouper ?</S.Text>
              <S.ButtonFlex>
                <button
                  className="minus"
                  disabled={realEstateLoans.length === 0}
                  onClick={() => handleImmoblierRemoveListItem()}
                >
                  -
                </button>
                <div className="value">{realEstateLoans.length}</div>
                <button
                  className="plus"
                  disabled={realEstateLoans.length === 8}
                  onClick={() => handleImmoblierAddFields()}
                >
                  +
                </button>
              </S.ButtonFlex>
            </S.CreditsFlex>
            {realEstateLoans.map((item: any, index: any) => {
              return (
                <S.Container>
                  <span>Crédit immobilier {index + 1}</span>
                  <div className="actual">
                    <NumericInput
                      class="to-validate trackable-blur"
                      label="Mensualité actuelle"
                      maxLength="9"
                      placeholder="Montant"
                      value={item.emi}
                      onLetterChanged={(e) => ImmobilierEmiChange(item.id, e)}
                      onInputChange={(e) => ImmobilierEmiChange(item.id, e)}
                      replacement={CreditsProjectMensualitesRules.replacement}
                      customValidityPattern={CreditsProjectMensualitesRules.customValidityPattern}
                      required
                    />
                  </div>
                  <div className="previous">
                    <NumericInput
                      class="to-validate trackable-blur"
                      label="Capital restant dû"
                      maxLength="9"
                      placeholder="Montant"
                      suffix="€"
                      value={item.amount}
                      onLetterChanged={(e) => ImmobilierAmountChange(item.id, e)}
                      onInputChange={(e) => ImmobilierAmountChange(item.id, e)}
                      replacement={CreditsProjectRestantRules.replacement}
                      customValidityPattern={CreditsProjectRestantRules.customValidityPattern}
                      required
                    />
                  </div>
                </S.Container>
              );
            })}
            {realEstateLoans.length > 0 && (
              <S.SumFlex>
                <S.SumFlexBlock>
                  <div className="text">Total des mensualités: </div>
                  <div className="value">{localeString(immoblierTotal1, ' ', 3)} €</div>
                </S.SumFlexBlock>
                <S.SumFlexBlock>
                  <div className="text">Total du capital restant dû: </div>
                  <div className="value">{localeString(immoblierTotal2, ' ', 3)} €</div>
                </S.SumFlexBlock>
              </S.SumFlex>
            )}
          </>
        )}

        {/* consumer credits */}
        <>
          <S.CreditsFlex>
            <S.Text>Combien de crédit(s) à la consommation souhaitez-vous regrouper ?</S.Text>
            <S.ButtonFlex>
              <button
                className="minus"
                disabled={consumerLoans.length === 0}
                onClick={() => handleConsumerRemoveListItem()}
              >
                -
              </button>
              <span className="value">{consumerLoans.length}</span>
              <button className="plus" disabled={consumerLoans.length === 8} onClick={() => handleConsumerAddFields()}>
                +
              </button>
            </S.ButtonFlex>
          </S.CreditsFlex>

          {consumerLoans.map((item: any, index: any) => {
            return (
              <S.Container>
                <span>Crédit à la consommation {index + 1}</span>
                <div className="actual">
                  <NumericInput
                    class="to-validate trackable-blur"
                    label="Mensualité actuelle"
                    maxLength="9"
                    placeholder="Montant"
                    value={item.emi}
                    onLetterChanged={(e) => ConsumerEmiChange(item.id, e)}
                    onInputChange={(e) => ConsumerEmiChange(item.id, e)}
                    replacement={CreditsProjectMensualitesRules.replacement}
                    customValidityPattern={CreditsProjectMensualitesRules.customValidityPattern}
                    required
                  />
                </div>
                <div className="previous">
                  <NumericInput
                    class="to-validate trackable-blur"
                    label="Capital restant dû"
                    maxLength="9"
                    placeholder="Montant"
                    suffix="€"
                    value={item.amount}
                    onLetterChanged={(e) => ConsumerAmountChange(item.id, e)}
                    onInputChange={(e) => ConsumerAmountChange(item.id, e)}
                    replacement={CreditsProjectRestantRules.replacement}
                    customValidityPattern={CreditsProjectRestantRules.customValidityPattern}
                    required
                  />
                </div>
              </S.Container>
            );
          })}
          {consumerLoans.length > 0 && (
            <S.SumFlex>
              <S.SumFlexBlock>
                <div className="text">Total des mensualités: </div>
                <div className="value">{localeString(consumerTotal1, ' ', 3)} €</div>
              </S.SumFlexBlock>
              <S.SumFlexBlock>
                <div className="text">Total du capital restant dû: </div>
                <div className="value">{localeString(consumerTotal2, ' ', 3)} €</div>
              </S.SumFlexBlock>
            </S.SumFlex>
          )}
          <S.Info>
            <S.TextDiv>
              <span>
                Renseignez ici l’ensemble des crédits à la consommation (auto, électro-ménager, travaux,...) que vous
                souhaitez regrouper.
              </span>
            </S.TextDiv>
          </S.Info>
        </>
      </S.CreditsContainer>
    </>
  );
};

export default Credits;
